module.exports = __webpack_public_path__ + "static/img/IS.02fa48aa.svg";